import { useQuery } from '@tanstack/react-query';
import { demoConfigService, type DemoConfigDisplay } from '../services/demoConfig.service';

export function useDemoConfig(id: string | undefined) {
  return useQuery<DemoConfigDisplay>({
    queryKey: ['demoConfig', id],
    queryFn: () => demoConfigService.getDemoConfig(id!),
    enabled: !!id,
    retry: false,
  });
}
